import React, { SVGProps } from 'react';

const WalletIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.4238 5.77767C3.4238 5.63034 3.48233 5.48903 3.58651 5.38485C3.69069 5.28067 3.832 5.22214 3.97933 5.22214H15.6456C15.9402 5.22214 16.2228 5.10508 16.4312 4.89671C16.6396 4.68835 16.7566 4.40574 16.7566 4.11107C16.7566 3.8164 16.6396 3.53379 16.4312 3.32542C16.2228 3.11706 15.9402 3 15.6456 3H3.97933C3.24265 3 2.53614 3.29265 2.01522 3.81356C1.49431 4.33448 1.20166 5.04099 1.20166 5.77767V18.555C1.20166 19.1443 1.43578 19.7095 1.85251 20.1263C2.26924 20.543 2.83445 20.7771 3.4238 20.7771H18.9788C19.5681 20.7771 20.1333 20.543 20.5501 20.1263C20.9668 19.7095 21.2009 19.1443 21.2009 18.555V8.55535C21.2009 7.966 20.9668 7.40079 20.5501 6.98406C20.1333 6.56733 19.5681 6.33321 18.9788 6.33321H3.97933C3.832 6.33321 3.69069 6.27468 3.58651 6.1705C3.48233 6.06631 3.4238 5.92501 3.4238 5.77767ZM15.09 15.2218C15.532 15.2218 15.9559 15.0462 16.2685 14.7336C16.581 14.4211 16.7566 13.9972 16.7566 13.5552C16.7566 13.1131 16.581 12.6892 16.2685 12.3767C15.9559 12.0641 15.532 11.8886 15.09 11.8886C14.648 11.8886 14.2241 12.0641 13.9116 12.3767C13.599 12.6892 13.4234 13.1131 13.4234 13.5552C13.4234 13.9972 13.599 14.4211 13.9116 14.7336C14.2241 15.0462 14.648 15.2218 15.09 15.2218Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default WalletIcon;
